import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const VerifyEmail = () =>
{
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || "your email address";

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 shadow-xl rounded-2xl p-8 w-full max-w-md">

        <h1 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-6">
          Verify Your Email
        </h1>

        <p className="text-center text-gray-700 dark:text-gray-300 mb-4">
          We've sent a verification email to
        </p>

        <p className="text-center font-semibold text-blue-600 break-all mb-6">
          {email}
        </p>

        <p className="text-gray-600 dark:text-gray-400 text-center mb-8">
          Please open your inbox and click the verification link before signing
          in.
        </p>

        <div className="space-y-3">

          <button
            onClick={() => navigate("/signin")}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition"
          >
            Back to Sign In
          </button>

        </div>

      </div>
    </div>
  );
};

export default VerifyEmail;